import React, { useEffect, useLayoutEffect, useRef, useState, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Table from '../../core/common/dataTable/index';
import { useHeaderFilters } from '../../context/HeaderFilterContext';
import useDynamicPageSize from '../../useDynamicPageSize';
import Footer from '../../Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast, ToastContainer } from "react-toastify";
import nodeApi from "../../nodeApi";
import JobDescriptionField from './JobDescriptionField';
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery, decryptQuery } from "../../utils/encryption";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";
import CommonSelect, { Option } from "../../core/common/commonSelect";
import TextareaAutosize from 'react-textarea-autosize';
import ScheduleInterviewModal from "../interviews/ScheduleInterviewModal";
import { REACT_APP_CAREER_API_BASE_URL } from "../../environment";

type JobOpeningType = {
  id: number;
  job_profile: string;
  job_description: string;
  job_type?: string;
  job_department?: string;
  job_benefits?: string;
  job_requirements?: string;
  skills: string[];
  required_experience_min_years: number | null;
  required_experience_max_years: number | null;
  job_location: string;
  status: string;
  deleted_at: string | null;
  created_at: string;
  updated_at: string;
};
type ModalMode = "add" | "edit";

type EmployeeFiltersProps = {
  searchTerm: string;
  onSearchTermChange: (val: string) => void;
  onAdd: () => void;
  onResetFilters: () => void;
  statusFilter: StatusOption;
  onStatusChange: (opt: StatusOption | null) => void;
  showReset: boolean;
  isActiveFilter: boolean;
};
type JobStatus = "active" | "inactive" | "all";

type StatusOption = {
  label: string;
  value: JobStatus;
};
type JobOpeningFiltersProps = {
  searchTerm: string;
  onSearchTermChange: (v: string) => void;
  statusFilter: StatusOption;
  onStatusChange: (opt: StatusOption) => void;
  onResetFilters: () => void;
  showReset: boolean;
  onAdd: () => void;
};

const STATUS_OPTIONS: StatusOption[] = [
  { label: "All", value: "all" },
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];
const JobOpeningFilters: React.FC<EmployeeFiltersProps> = ({
  searchTerm,
  onSearchTermChange,
  onAdd,
  onResetFilters,
  statusFilter,
  onStatusChange,
  isActiveFilter,
}) => {
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);

  // close on outside click / ESC (same as Resumes)
  useEffect(() => {
    const clickOutside = (e: MouseEvent) => {
      if (
        showMobileFilters &&
        modalRef.current &&
        !modalRef.current.contains(e.target as Node)
      ) {
        setShowMobileFilters(false);
      }
    };
    const onEsc = (e: KeyboardEvent) =>
      e.key === "Escape" && setShowMobileFilters(false);

    document.addEventListener("mousedown", clickOutside);
    document.addEventListener("keydown", onEsc);
    return () => {
      document.removeEventListener("mousedown", clickOutside);
      document.removeEventListener("keydown", onEsc);
    };
  }, [showMobileFilters]);

  return (
    <div className="upper-absolute-class">
      {/* ================= MOBILE ================= */}
      <div className="d-lg-none">
        <div className="d-flex align-items-center gap-2" style={{ paddingRight: 12 }}>
          {(!isActiveFilter || searchTerm.trim()) && (
            <button
              className="btn btn-outline-primary add_btn_size"
              onClick={onResetFilters}
              title="Reset"
            >
              <i className="ti ti-refresh" />
            </button>
          )}

          <input
            type="text"
            className="form-control search-size w-100"
            placeholder="Search…"
            value={searchTerm}
            onChange={(e) => onSearchTermChange(e.target.value)}
          />

          <button
            className="btn btn-outline-primary add_btn_size"
            onClick={onAdd}
            title="Add Job"
          >
            <i className="ti ti-circle-plus" />
          </button>

          <button
            className="btn btn-outline-primary add_btn_size"
            onClick={() => setShowMobileFilters(true)}
          >
            <i className="ti ti-filter" />
          </button>
        </div>

        {/* Mobile filter modal */}
        {showMobileFilters && (
          <div
            className="modal-backdrop"
            style={{
              position: "fixed",
              inset: 0,
              backgroundColor: "rgba(0,0,0,0.3)",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",
              paddingTop: "103px",
              zIndex: 1050,
            }}
          >
            <div
              ref={modalRef}
              className="bg-white shadow rounded p-3 mt-2 filter_select"
              style={{ width: "90%", maxWidth: 400 }}
            >
              <CommonSelect
                className="select header-filter-select"
                forceFullWidth
                options={STATUS_OPTIONS}
                value={statusFilter}
                onChange={(opt) => {
                  if (opt) onStatusChange(opt as StatusOption);
                  setShowMobileFilters(false);
                }}
                placeholder="Status"
              />
            </div>
          </div>
        )}
      </div>

      {/* ================= DESKTOP ================= */}
      <div className="Employee-filters d-none d-lg-flex align-items-center flex-wrap gap-2">
        {(!isActiveFilter || searchTerm.trim()) && (
          <button
            className="btn btn-outline-primary add_btn_size"
            onClick={onResetFilters}
            title="Reset"
          >
            <i className="ti ti-refresh" />
          </button>
        )}

        <input
          type="text"
          className="form-control search-size"
          placeholder="Search…"
          value={searchTerm}
          onChange={(e) => onSearchTermChange(e.target.value)}
        />

        {/* SAME CommonSelect width & height */}
       <CommonSelect
  className="select header-filter-select"
  options={STATUS_OPTIONS}
  value={statusFilter}
  onChange={(opt) => {
    if (opt) onStatusChange(opt as StatusOption);
  }}
  placeholder="Status"
/>


        <button
          className="btn btn-outline-primary add_btn_size"
         
          onClick={onAdd}
        >
          <i className="ti ti-circle-plus" />
        </button>
      </div>
    </div>
  );
};


// Debounce hook
function useDebounce<T>(value: T, delay = 500): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const h = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(h);
  }, [value, delay]);
  return debounced;
}

const JobOpenings: React.FC = () => {
  const hasHydratedFromUrl = useRef(false);
  const [statusFilter, setStatusFilter] = useState<StatusOption>(
  STATUS_OPTIONS.find(s => s.value === "active")!
);
  const isActiveFilter = statusFilter.value === "active";
  // Pagination state
  const { setFilters } = useHeaderFilters();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageCandidates, setCurrentPageCandidates] = useState(1);
  const pageSize = useDynamicPageSize();
  const isInitialFetch = useRef(true);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [totalItemsCandidates, setTotalItemsCandidates] = useState<number>(0);
  const [tableHeight, setTableHeight] = useState<number>(0);
  const [loading, setLoading] = useState(true);
  const [loadingCandidates, setLoadingCandidates] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermCandidates, setSearchTermCandidates] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 300);
  const debouncedSearchTermCandidates = useDebounce(searchTermCandidates, 300);
  const { encryptedQuery } = useParams<{ encryptedQuery?: string }>();
  const isSyncingFromUrl = useRef(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoCandidates, setInfoCandidates] = useState<any[]>([]);
  const [loadingInfoCandidates, setLoadingInfoCandidates] = useState(false);
  const [infoJob, setInfoJob] = useState<JobOpeningType | null>(null);
  const [infoPage, setInfoPage] = useState(1);
  const [infoTotal, setInfoTotal] = useState(0);
  const [infoSearchTerm, setInfoSearchTerm] = useState("");
  const debouncedInfoSearchTerm = useDebounce(infoSearchTerm, 300);
  const [allInfoCandidates, setAllInfoCandidates] = useState<any[]>([]);
  const [selectedInfoCandidate, setSelectedInfoCandidate] = useState<any>(null);
  const [allCandidates, setAllCandidates] = useState<any[]>([]);
  const [showLoadCandidateModal, setShowLoadCandidateModal] = useState(false);

  useLayoutEffect(() => {
    if (pageSize === 0) return; // Prevent setting height too early
    if (showLoadCandidateModal || showInfoModal) return;
    const calculateHeight = () => {
      const baseOffset = 194;
      const extraOffset = window.innerWidth <= 991 ? -43 : -81;
      const fixedOffset = baseOffset + extraOffset;

      const newHeight = window.innerHeight - fixedOffset;

      console.log('Calculated table height:', newHeight);
      console.log('fixedOffset:', fixedOffset);
      console.log('window.innerHeight:', window.innerHeight);
      console.log("totalItems :", totalItems);
      console.log("pagesize :", pageSize);
      setTableHeight(newHeight);
    };
    calculateHeight();
    window.addEventListener("resize", calculateHeight); // respond to window size changes

    return () => window.removeEventListener("resize", calculateHeight); // cleanup on unmount
  }, [showLoadCandidateModal, showInfoModal]);

  // Data state
  const [jobOpening, setJobOpening] = useState<JobOpeningType[]>([]);
  const [candidates, setCandidates] = useState<any>([]);
  const showCandidateTable =
    loadingCandidates || candidates.length > 0;
  const showInfoTable =
    loadingInfoCandidates || infoCandidates.length > 0;

  // const [allCandidates, setAllCandidates] = useState<any[]>([]);
  // Form state
  const [formData, setFormData] = useState<{
    job_profile: string;
    job_description: string;
    job_type: string;
    job_department: string;
    job_benefits: string;
    job_requirements: string;
    skills: string[];
    required_experience_min_years: number | null;
    required_experience_max_years: number | null;
    job_location: string;
    status: string;
  }>({
    job_profile: "",
    job_description: "",
    job_type: "",
    job_department: "",
    job_benefits: "",
    job_requirements: "",
    skills: [],
    required_experience_min_years: null,
    required_experience_max_years: null,
    job_location: "",
    status: "active",
  });

  const [modalMode, setModalMode] = useState<ModalMode>("add");
  const [editId, setEditId] = useState<number | null>(null);
  const [deleteId, setDeleteId] = useState<number | null>(null);

  // Validation error state
  const [formError, setFormError] = useState<{
    job_profile?: string;
    job_description?: string;
    job_type?: string;
    job_department?: string;
    job_benefits?: string;
    job_requirements?: string;
    required_experience?: string;
    job_location?: string;
    skills?: string;
  }>({});

  const [showInterviewModal, setShowInterviewModal] = useState(false);

  const [interviewMode, setInterviewMode] = useState<"schedule" | "load" | "newRound">("schedule");
  const [selectedCandidate, setSelectedCandidate] = useState<any>(null);

  type Candidate = {
    id: number;
    name: string;
    email: string;
    total_experience_months: number;
    ctc_info?: number;
    current_location: string;
  };

  const [selectedJob, setSelectedJob] = useState<JobOpeningType | null>(null);
const isResetting = useRef(false);

  const fetchJobOpenings = async () => {
    try {
      setLoading(true);
      const res = await nodeApi<any>(
        `/job-openings/all-job-openings`, {
        method: 'POST',
        body: { currentPage, pageSize, searchTerm: debouncedSearchTerm || "", active:
    statusFilter.value === "all"
      ? ""
      : statusFilter.value === "active",
},
      }
      );
      console.log("Raw API response:", res);
      setJobOpening(res?.data);
      setTotalItems(res?.pagination?.totalRecords);
    } catch (err: any) {
      console.error("Fetch error:", err.message);
    } finally {
      setLoading(false);
    }
  };
const fetchJobOpeningCandidates = async (job: JobOpeningType) => {
  try {
    setInfoJob(job);
    setShowInfoModal(true);
    setLoadingInfoCandidates(true);
    setInfoPage(1);

    const res = await nodeApi<any>(
      "/job-openings/get-candidates-by-job-opening",
      {
        method: "POST",
        body: {
          job_opening_id: job.id,
        },
      }
    );

    const list = res?.candidates ?? [];

    setAllInfoCandidates(list);
    setInfoCandidates(list);     
    setInfoTotal(list.length);
  } catch (err) {
    console.error(err);
    toast.error("Failed to load candidates");
  } finally {
    setLoadingInfoCandidates(false);
  }
};
useEffect(() => {
  if (showLoadCandidateModal || showInfoModal) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  return () => {
    document.body.style.overflow = "";
  };
}, [showLoadCandidateModal, showInfoModal]);


useEffect(() => {
  let filtered = allInfoCandidates;

  //  SEARCH (frontend side)
  if (infoSearchTerm.trim()) {
    const term = infoSearchTerm.toLowerCase();
    filtered = filtered.filter((c) =>
      c.name?.toLowerCase().includes(term) ||
      c.email?.toLowerCase().includes(term)
    );
  }

  //  PAGINATION (frontend side)
  const start = (infoPage - 1) * 12;
  const end = start + 12;

  setInfoCandidates(filtered.slice(start, end));
  setInfoTotal(filtered.length);
}, [allInfoCandidates, infoSearchTerm, infoPage]);



  useEffect(() => {
    setCurrentPageCandidates(1);
  }, [debouncedSearchTermCandidates]);

useEffect(() => {
  if (!showLoadCandidateModal || !selectedJob) return;
  // Only load candidates when modal opens or job changes, not on search term change
  loadCandidates(selectedJob);
}, [
  showLoadCandidateModal,
  selectedJob,
  currentPageCandidates,
  debouncedSearchTermCandidates,
]);


const loadCandidates = async (job: JobOpeningType) => {
  try {
    setInterviewMode("load");
    setSelectedJob(job);
    setShowLoadCandidateModal(true);
    setSelectedCandidate(null);
    setLoadingCandidates(true);

    const token = localStorage.getItem("token");

    const payload = {
      currentPage: currentPageCandidates,         
      pageSize: 12,         
      searchTerm: debouncedSearchTermCandidates, 
      job_profile: job.job_profile || "",
      // job_description: job.job_description
      //   ? job.job_description.replace(/<[^>]*>/g, "").trim()
      //   : "",

      required_experience_min_years:
        job.required_experience_min_years ?? 0,
      required_experience_max_years:
        job.required_experience_max_years ?? 0,
       job_skills: job.skills || [], 
      job_location: job.job_location || "",
    };

    const res = await fetch(
      `${REACT_APP_CAREER_API_BASE_URL}/api/search/resumes`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const data = await res.json();

    // STORE FULL DATASET
   setCandidates(data?.results ?? []);
   setTotalItemsCandidates(data?.pagination?.totalResults ?? 0);
  } catch (err) {
    console.error("Fetch resumes error:", err);
    toast.error("Failed to load resumes");
  } finally {
    setLoadingCandidates(false);
  }
};

// useEffect(() => {
//   // Filter candidates on the frontend using searchTermCandidates
//   let filtered = allCandidates;
//   if (searchTermCandidates.trim()) {
//     const term = searchTermCandidates.trim().toLowerCase();
//     filtered = allCandidates.filter((c: any) =>
//       (c.name && c.name.toLowerCase().includes(term)) ||
//       (c.email && c.email.toLowerCase().includes(term))
//     );
//   }
//   const start = (currentPageCandidates - 1) * 12;
//   const end = start + 12;
//   setCandidates(filtered.slice(start, end));
//   setTotalItemsCandidates(filtered.length);
// }, [allCandidates, currentPageCandidates, searchTermCandidates]);

useEffect(() => {
  fetchJobOpenings();
}, [currentPage, pageSize, debouncedSearchTerm, statusFilter.value]);


useEffect(() => {
  if (isSyncingFromUrl.current) return;

  updateFilterUrl({
    searchTerm: debouncedSearchTerm || null,
    status: statusFilter.value,
    currentPage,
  });
}, [debouncedSearchTerm, statusFilter.value, currentPage]);


  const navigate = useNavigate();
  const openInterviewFromInfoPopup = (candidate: any) => {
  if (!candidate?.interview_id) {
    toast.error("Interview not found for this candidate");
    return;
  }

  // Close info modal first
  setShowInfoModal(false);

  // Navigate to Interviews module & open rounds modal
  navigate(`/interviews?interviewId=${candidate.interview_id}`);
};

  const showReset =
    searchTerm.trim() !== "" ||
    statusFilter.value !== "active";
const handleResetFilters = () => {
  isSyncingFromUrl.current = true;

  setSearchTerm("");
  setStatusFilter(STATUS_OPTIONS.find(s => s.value === "active")!);
  setCurrentPage(1);

  navigate("/job-openings", { replace: true });

  requestAnimationFrame(() => {
    isSyncingFromUrl.current = false;
  });
};

  const handleResetFiltersCandidates = () => {
    setSearchTermCandidates("");
  };

  interface JobOpeningFilters {
    searchTerm: string | null;
    status?: JobStatus;
    currentPage?: number;
  }

  const defaultJobOpeningFilters: JobOpeningFilters = {
    searchTerm: null,
    status: "active",
    currentPage: 1,
  };

  const areJobOpeningFiltersDefault = (filters: JobOpeningFilters) => {
    return (
      (!filters.searchTerm || filters.searchTerm.trim() === "") &&
      (filters.status ?? "active") === "active" &&
      (filters.currentPage ?? 1) === defaultJobOpeningFilters.currentPage
    );
  };


useEffect(() => {
  if (!encryptedQuery || hasHydratedFromUrl.current) return;

  try {
    isSyncingFromUrl.current = true;

    const decoded = decodeURIComponent(encryptedQuery);
    const result = decryptQuery(decoded);

    if (result && typeof result === "object") {
      const data = result as JobOpeningFilters;

      setSearchTerm(data.searchTerm || "");
      setStatusFilter(
        STATUS_OPTIONS.find(s => s.value === data.status) || STATUS_OPTIONS[0]
      );
      setCurrentPage(data.currentPage ?? 1);
    }
     hasHydratedFromUrl.current = true;
  } catch (e) {
    console.warn("Failed to decrypt job openings query:", e);
  } finally {
    requestAnimationFrame(() => {
      isSyncingFromUrl.current = false;
    });
  }
}, [encryptedQuery]);


  const updateFilterUrl = (
    filters: JobOpeningFilters,
    baseRoute: string = "/job-openings"
  ) => {
    if (areJobOpeningFiltersDefault(filters)) {
      navigate(baseRoute, { replace: true });

    } else {
      const encrypted = encryptQuery(filters);
      const encoded = encodeURIComponent(encrypted);
      navigate(`${baseRoute}/${encoded}`, { replace: false });
    }
  };


  const filtersNode = useMemo(
    () => (
      <JobOpeningFilters
        onResetFilters={handleResetFilters}
        searchTerm={searchTerm}
        onSearchTermChange={(val) => {
          setSearchTerm(val);
          setCurrentPage(1);
        }}
        statusFilter={statusFilter}
        onStatusChange={(opt) => {
          setStatusFilter(opt || STATUS_OPTIONS[0]);
          setCurrentPage(1);
        }}
        showReset={showReset}
        isActiveFilter={isActiveFilter}
        onAdd={() => openModal("add")}
      />
    ),
    [searchTerm, statusFilter, isActiveFilter]
  );

  useEffect(() => {
    setFilters(filtersNode);
    return () => {
      setFilters(null);
    };
  }, [filtersNode]);

  // open modal (add or edit)
  const openModal = (mode: ModalMode, rec?: JobOpeningType) => {
    setFormError({});
    setModalMode(mode);
    setFormData({
      job_profile: "",
      job_description: "",
      job_type: "",
      job_department: "",
      job_benefits: "",
      job_requirements: "",
      required_experience_min_years: null,
      required_experience_max_years: null,
      job_location: "",
      status: "active",
      skills: [],
    });
    setEditId(null);

    if (mode === "edit" && rec) {
      setFormData({
        job_profile: rec.job_profile,
        job_description: rec.job_description,
        job_type: rec.job_type || "",
        job_department: rec.job_department || "",
        job_benefits: rec.job_benefits || "",
        job_requirements: rec.job_requirements || "",
        required_experience_min_years: rec.required_experience_min_years,
        required_experience_max_years: rec.required_experience_max_years,
        job_location: rec.job_location,
        status: rec.status,
        skills: rec.skills || [],
      });
      setEditId(rec.id);
    }

    const el = document.getElementById("payheader_modal");
    if (el) {
      const bsModal = (window as any).bootstrap.Modal.getOrCreateInstance(el);
      bsModal.show();
    }
  };

  // hide modal + backdrop cleanup
  const hideModal = (modalId: string) => {
    const el = document.getElementById(modalId);
    if (!el || !(window as any).bootstrap?.Modal) return;

    const instance = (window as any).bootstrap.Modal.getInstance(el);
    if (instance) {
      instance.hide();
    }

    // after fade, remove any stray backdrops & body locks
    setTimeout(() => {
      document.querySelectorAll(".modal-backdrop").forEach((b) => b.remove());
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
    }, 300);
  };

  // Handlers
  const handleAddInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (value.trim() !== "") {
      setFormError((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const handleSubmit = async () => {
    const errors: any = {};
    console.log("Form data:", formData);
    if (!formData.job_profile.trim())
      errors.job_profile = "Job Profile is required.";
    if (!formData.job_description.trim())
      errors.job_description = "Job Description is required.";

    if (!formData.skills.length)
      errors.skills = "At least one skill is required.";

    if (!formData.job_type.trim())
      errors.job_type = "Job Type is required.";

    if (!formData.job_department.trim())
      errors.job_department = "Job Department is required.";

    if (!formData.job_benefits.trim())
      errors.job_benefits = "Job Benefits are required.";

    if (!formData.job_requirements.trim())
      errors.job_requirements = "Job Requirements are required.";

    const min = formData.required_experience_min_years;
    const max = formData.required_experience_max_years;

    if (min == null || max == null) {
      errors.required_experience = "Experience is required.";
    }
    else if (isNaN(min) || isNaN(max)) {
      errors.required_experience = "Experience values must be numbers.";
    }
    else if (min < 0 || max < 0) {
      errors.required_experience = "Experience cannot be negative.";
    }
    else if (min > max) {
      errors.required_experience = "Min years cannot be greater than max years.";
    }
    else if (min === max) {
      errors.required_experience = "Min and Max years cannot be the same.";
    }

    if (!formData.job_location.trim())
      errors.job_location = "Job Location is required.";

    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }
    try {
      const body: Record<string, any> = {
        job_profile: formData.job_profile.trim(),
        job_description: formData.job_description.trim(),
        job_type: formData.job_type,
        job_department: formData.job_department,
        job_benefits: formData.job_benefits,
        job_requirements: formData.job_requirements,
        required_experience_min_years: formData.required_experience_min_years,
        required_experience_max_years: formData.required_experience_max_years,
        job_location: formData.job_location.trim(),
        status: formData.status.trim(),
        skills: formData.skills,
      };
      if (modalMode === "edit" && editId != null) body.id = editId;
      const res = await nodeApi<{ success: boolean; data: any; error?: string }>(
        "/job-openings/save-job-opening",
        {
          method: "POST",
          body,
        }
      );
      if (res.success) {
        if (modalMode === "edit") {
          await fetchJobOpenings();
        } else {
          // For add mode:
          setTotalItems((prevCount) => {
            const newCount = prevCount + 1;
            setCurrentPage(1);
            fetchJobOpenings();
            return newCount;
          });
        }

        hideModal("payheader_modal");
        toast.success(
          modalMode === "add"
            ? "Job opening added successfully!"
            : "Job opening updated successfully!"
        );
      }
    } catch (err: any) {
      const backendMessage = err?.response?.data?.message;
      console.error("Error:", backendMessage);
      toast.error(backendMessage || "API failed");
    }
  };

  const handleDelete = async (id: number) => {
    try {
      const res = await nodeApi<any>(
        `/job-openings/delete-job-opening/${id}`,
        { method: "DELETE" }
      );
      if (res.success) {
        setTotalItems((prevCount) => prevCount - 1);
        toast.success("Job opening deleted successfully!");
        // Calculate the total pages after deletion
        const totalPages = Math.ceil((totalItems - 1) / pageSize);
        // If the current page number is now greater than totalPages, move back one page
        if (currentPage > totalPages) {
          setCurrentPage(totalPages > 0 ? totalPages : 1);
        } else {
          await fetchJobOpenings();
        }
      } else {
        toast.error(res.error || "Failed to delete job opening.");
      }
    } catch (err: any) {
      const backendMessage = err?.response?.data?.message;
      console.error("Error:", backendMessage);
      toast.error(backendMessage || "API failed");
    }
  };

  const handleBlur = (
    e: React.FocusEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    if (value.trim() === "") {
      const label =
        name
          .split("_")
          .map(
            (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
          )
          .join(" ");
      setFormError((prev) => ({
        ...prev,
        [name]: `${label} is required.`,
      }));
    }
  };

  const openDeleteModal = (id: number) => {
    setDeleteId(id);
    const modalElement = document.getElementById("top-modal");
    if (modalElement) {
      const modalInstance = (window as any).bootstrap.Modal.getOrCreateInstance(
        modalElement
      );
      modalInstance.show();
    }
  };

  const fmtMonths = (m?: number) => {
    const n = Number(m) || 0;
    const y = Math.floor(n / 12);
    const r = n % 12;
    if (y && r) return `${y} year${y > 1 ? 's' : ''} ${r} month${r > 1 ? 's' : ''}`;
    if (y) return `${y} year${y > 1 ? 's' : ''}`;
    return `${r} month${r !== 1 ? 's' : ''}`;
  };

  const handleScheduleInterview = (job: JobOpeningType) => {
    setInterviewMode("schedule");
    setShowLoadCandidateModal(false);
    setSelectedJob(job);
    setShowInterviewModal(true);
  };

  const handleLoadInterview = (job: JobOpeningType) => {
    setInterviewMode("load");
    setSelectedJob(job);
    setShowLoadCandidateModal(true);
    setSelectedCandidate(null)
  };

  const columns = [
    {
      title: "Job Profile",
      dataIndex: "job_profile",
      width: 180,
      ellipsis: true,
      render: (t: string) => t || "-",
    },
    {
      title: "Job Description",
      dataIndex: "job_description",
      width: 280,
      ellipsis: true,
      render: (html: string) => {
        const text = html
          .replace(/<[^>]+>/g, " ")
          .replace(/&nbsp;/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        return <span title={text}>{text}</span>;
      },
    },
    {
      title: "Experience Required",
      dataIndex: "required_experience_min_years",
      width: 180,
      render: (_: any, record: any) => {
        const min = record.required_experience_min_years;
        const max = record.required_experience_max_years;

        if (min == null || max == null) return "-";

        return `${min}-${max} years`;
      },
    },
    {
      title: "Job Location",
      dataIndex: "job_location",
      width: 180,
      ellipsis: true,
      render: (t: string) => t || "-",
    },
    {
      title: "Created On",
      dataIndex: "created_at",
      width: 180,
      render: (date: string) =>
        date ? dayjs(date).format("DD-MMM-YYYY, h:mm A") : "-",
    },
    {
      title: "Status",
      dataIndex: "status",
      width: 120,
      align: "center",
      render: (status: string) =>
        status === "active" ? (
          <span style={{
            background: "#9FF4C4",
            color: "#34714E",
            padding: "2px 6px",
            borderRadius: "4px",
            width: "80px",
            textAlign: "center",
            height: "20px",
            lineHeight: "17px",
            display: "inline-block",
          }}>Active</span>
        ) : (
          <span style={{
            background: "#FF060661",
            color: "#C24242",
            padding: "2px 6px",
            borderRadius: "4px",
            width: "80px",
            textAlign: "center",
            height: "20px",
            lineHeight: "17px",
            display: "inline-block",
          }}>Inactive</span>
        ),
    },
    {
      title: "Interview",
      dataIndex: "interview",
      width: 300,
      align: "center",
      render: (_: any, rec: JobOpeningType) => {
        const isInactive = rec.status === "inactive" || !!rec.deleted_at;

        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "8px", flexWrap: "nowrap" }}
          >
            <button
              className="btn btn-sm btn-outline-primary"
              style={{ padding: "2px 6px", lineHeight: "1.2", fontSize: "0.8rem" }}
              onClick={() => !isInactive && handleScheduleInterview(rec)}
              disabled={isInactive}
            >
              Add Candidate
            </button>

        <button
          className="btn btn-sm btn-outline-primary"
          style={{ padding: "2px 6px", lineHeight: "1.2", fontSize: "0.8rem" }}
         onClick={() => {
                if (isInactive) return;
                setSelectedJob(rec);
                setShowLoadCandidateModal(true);
                setSelectedCandidate(null);
              }}

          disabled={isInactive}
        >
          Load Candidate
        </button>
      </div>
    );
  },
},
  {
    title: "Action",
    dataIndex: "actions",
    width: 95,
    align: "center",
    render: (_: any, rec: JobOpeningType) => {
  const isSoftDeleted = !!rec.deleted_at;

        return (
          <div
            className="action-icon d-inline-flex"
            style={{ opacity: isSoftDeleted ? 0.4 : 1 }}
          >
            {/* INFO ICON */}
            <Link
              to="#"
              title="View candidates"
              onClick={() => fetchJobOpeningCandidates(rec)}
            >
              <i className="ti ti-info-circle" />
            </Link>
            <Link
              to="#"
              onClick={isSoftDeleted ? undefined : () => openModal("edit", rec)}
              style={{ pointerEvents: isSoftDeleted ? "none" : "auto" }}
            >
              <i className="ti ti-edit" />
            </Link>

            <Link
              to="#"
              onClick={isSoftDeleted ? undefined : () => openDeleteModal(rec.id)}
              style={{ pointerEvents: isSoftDeleted ? "none" : "auto" }}
            >
              <i className="ti ti-trash" />
            </Link>
          </div>
        );
      },
    },
  ];

  const handleSuccess = () => {
    toast.success("Interview scheduled successfully!");
  };

  const handleCloseModal = () => {
    setSelectedJob(null);
    setShowInterviewModal(false);
  };
const [skillInput, setSkillInput] = useState("");

const SKILL_ALLOWED_RE = /^[A-Za-z0-9.+#\-_/&() ]+$/;

const normalizeSkills = (raw: string) => {
  return raw
    .split(/[,;\n]+/)
    .map(s => s.trim())
    .filter(Boolean)
    .filter(s => SKILL_ALLOWED_RE.test(s));
};

const addSkill = () => {
  const tokens = normalizeSkills(skillInput);
  if (!tokens.length) return;

  setFormData(prev => {
    const existing = new Set(prev.skills.map(s => s.toLowerCase()));
    const newSkills = [...prev.skills];

    tokens.forEach(t => {
      if (!existing.has(t.toLowerCase())) {
        newSkills.push(t);
      }
    });

    return { ...prev, skills: newSkills };
  });

  setFormError(prev => ({
    ...prev,
    skills: ""
  }));

  setSkillInput("");
};

const removeSkill = (index: number) => {
  setFormData(prev => {
    const updatedSkills = prev.skills.filter((_, i) => i !== index);

    if (updatedSkills.length === 0) {
      setFormError(prevErr => ({
        ...prevErr,
        skills: "At least one skill is required."
      }));
    }

    return {
      ...prev,
      skills: updatedSkills
    };
  });
};

const handleSkillsBlur = () => {
  const tokens = normalizeSkills(skillInput);

  let totalSkills = formData.skills.length;

  // If user typed something, it will be added
  if (tokens.length) {
    totalSkills += tokens.length;
    addSkill();
  }

  if (totalSkills === 0) {
    setFormError(prev => ({
      ...prev,
      skills: "At least one skill is required."
    }));
  } else {
    setFormError(prev => ({
      ...prev,
      skills: ""
    }));
  }
};




  return (
    <>
      <div className="page-wrapper d-flex flex-column">
        <div className="content flex-grow-1 " >
          <div className="card card-margin-bottom" ><div className="card-body p-0" id="payheader-list" style={{ height: tableHeight, display: "flex", flexDirection: "column" }}>
            <Table style={{ flex: 1 }} loading={loading} currentPage={currentPage} dataSource={jobOpening} columns={columns} onPageChange={setCurrentPage} totalItems={totalItems} pageSize={pageSize} />
          </div></div></div>

        {/* Add-Edit Modal */}
        <div className="modal fade" id="payheader_modal">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">
                  {modalMode === "add" ? "Add Job Opening" : "Edit Job Opening"}
                </h4>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => hideModal("payheader_modal")}
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <div className="modal-body pb-0">
                <div className="mb-3">
                  <label className="form-label">
                    Job Profile <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="job_profile"
                    onChange={handleAddInputChange}
                    value={formData.job_profile}
                  />
                  {formError.job_profile && (
                    <small className="text-danger">{formError.job_profile}</small>
                  )}
                </div>
                <JobDescriptionField
                  formData={formData}
                  formError={formError}
                  handleBlur={handleBlur}
                  setFormData={setFormData}
                  setFormError={setFormError}
                />
                <div className="row">
                  {/* Job Type */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Job Type <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      name="job_type"
                      value={formData.job_type}
                      onChange={handleAddInputChange}
                      onBlur={handleBlur}
                      placeholder="Full Time / Contract / Remote"
                    />

                    {formError.job_type && (
                      <small className="text-danger">{formError.job_type}</small>
                    )}
                  </div>

                  {/* Job Department */}
                  <div className="col-md-6 mb-3">
                    <label className="form-label">
                      Job Department <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      name="job_department"
                      value={formData.job_department}
                      onChange={handleAddInputChange}
                      onBlur={handleBlur}
                      placeholder="Engineering / Marketing / HR"
                    />

                    {formError.job_department && (
                      <small className="text-danger">{formError.job_department}</small>
                    )}
                  </div>
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Job Benefits <span className="text-danger">*</span>
                  </label>

                  <textarea
                    className="reason-height form-control"
                    rows={6}
                    name="job_benefits"
                    value={formData.job_benefits}
                   onChange={(e) => {
                      const value = e.target.value;

                      setFormData((s) => ({ ...s, job_benefits: value }));

                      if (value.trim()) {
                        setFormError((prev) => ({ ...prev, job_benefits: "" }));
                      }
                    }}
                    onBlur={handleBlur}
                    placeholder="Health Insurance, Flexible Working Hours, Remote Work..."
                  />

                  {formError.job_benefits && (
                    <small className="text-danger">{formError.job_benefits}</small>
                  )}
                </div>
                <div className="mb-3">
                  <label className="form-label">
                    Job Requirements <span className="text-danger">*</span>
                  </label>

                  <textarea
                    className="reason-height form-control"
                    rows={6}
                    name="job_requirements"
                    value={formData.job_requirements}
                    onChange={(e) => {
                      const value = e.target.value;

                      setFormData((s) => ({ ...s, job_requirements: value }));

                      if (value.trim()) {
                        setFormError((prev) => ({ ...prev, job_requirements: "" }));
                      }
                    }}
                    onBlur={handleBlur}
                    placeholder="Bachelor's degree, 3+ years experience in React..."
                  />

                  {formError.job_requirements && (
                    <small className="text-danger">{formError.job_requirements}</small>
                  )}
                </div>
               <div className="col-md-12">
                  <label className="form-label">
                    Job Skills <span className="text-danger">*</span>
                  </label>

                  <div className="input-group mb-2">
                   <input
                      className="form-control"
                      placeholder="Type skill and press Enter"
                      value={skillInput}
                      onChange={(e) => {
                        setSkillInput(e.target.value);
                        if (e.target.value.trim()) {
                          setFormError(prev => ({ ...prev, skills: "" }));
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === ",") {
                          e.preventDefault();
                          addSkill();
                          setFormError(prev => ({ ...prev, skills: "" }));
                        }
                      }}
                      onBlur={handleSkillsBlur}
                    />


                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={addSkill}
                    >
                      Add
                    </button>
                  </div>

                  {/* Chips */}
                  {/* Skills Container */}
                <div
                  className="border rounded p-2"
                  style={{
                    minHeight: "44px",
                    background: "#fafafa",
                  }}
                >
                  {formData.skills.length === 0 ? (
                    <span className="text-muted small">No skills added</span>
                  ) : (
                    <div className="d-flex flex-wrap gap-2">
                      {formData.skills.map((skill, index) => (
                        <span
                          key={index}
                          className="badge bg-white border text-dark d-flex align-items-center px-2 py-1"
                          style={{ borderRadius: "6px" }}
                        >
                          <span>{skill}</span>
                          <i
                            className="ti ti-x ms-2"
                            style={{ cursor: "pointer", fontSize: "14px" }}
                            onClick={() => removeSkill(index)}
                          />
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                {formError.skills && (
                  <small className="text-danger d-block mt-1">
                    {formError.skills}
                  </small>
                )}

                </div>


                {/* Required Experience (min–max years) */}
                <div className="mb-3 mt-3">
                  <label className="form-label">
                    Experience Required <span className="text-danger">*</span>
                  </label>
                  <div className="d-flex gap-2">

                    {/* Min Years Input */}
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className="form-control"
                      placeholder="Min Years"
                      value={
                        formData.required_experience_min_years !== null &&
                          formData.required_experience_min_years !== undefined
                          ? formData.required_experience_min_years.toString()
                          : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        if (!/^\d*$/.test(val)) return; // only digits

                        setFormData((s) => ({
                          ...s,
                          required_experience_min_years: val === "" ? null : parseInt(val, 10),
                        }));

                        setFormError((prev) => ({
                          ...prev,
                          required_experience: "",
                        }));
                      }}
                    />

                    {/* Max Years Input */}
                    <input
                      type="text"
                      inputMode="numeric"
                      pattern="[0-9]*"
                      className="form-control"
                      placeholder="Max Years"
                      value={
                        formData.required_experience_max_years !== null &&
                          formData.required_experience_max_years !== undefined
                          ? formData.required_experience_max_years.toString()
                          : ""
                      }
                      onChange={(e) => {
                        const val = e.target.value;
                        if (!/^\d*$/.test(val)) return;

                        setFormData((s) => ({
                          ...s,
                          required_experience_max_years: val === "" ? null : parseInt(val, 10),
                        }));

                        setFormError((prev) => ({
                          ...prev,
                          required_experience: "",
                        }));
                      }}
                    />
                  </div>

                  {/* Error Messages */}
                  {formError.required_experience && (
                    <small className="text-danger d-block mt-1">
                      {formError.required_experience}
                    </small>
                  )}

                  {/* Display formatted experience */}
                  <small className="text-muted d-block mt-1">
                    {
                      formData.required_experience_min_years != null &&
                        formData.required_experience_max_years != null
                        ? `${formData.required_experience_min_years}-${formData.required_experience_max_years} years`
                        : ""}
                  </small>
                </div>

                <div className="mb-3">
                  <label className="form-label">
                    Job Location <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    name="job_location"
                    onChange={handleAddInputChange}
                    value={formData.job_location}
                  />
                  {formError.job_location && (
                    <small className="text-danger">{formError.job_location}</small>
                  )}
                </div>
              </div>
              <div className="mb-3">
                <div className="form-check ms-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="status"
                    name="status"
                    checked={formData.status === "active"}
                    onChange={(e) =>
                      setFormData((s) => ({
                        ...s,
                        status: e.target.checked ? "active" : "inactive",
                      }))
                    }
                  />
                  <label className="form-check-label form-label" htmlFor="status">
                    Active
                  </label>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-light me-2"
                  onClick={() => hideModal("payheader_modal")}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleSubmit}>
                  {editId ? "Update" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Delete Confirmation Modal */}
        <div id="top-modal" className="modal fade" tabIndex={-1}>
          <div className="modal-dialog modal-top">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Delete Job Opening</h4>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this job opening?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-cancel" data-bs-dismiss="modal">
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => deleteId !== null && handleDelete(deleteId)}
                  data-bs-dismiss="modal"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Candidate Modal */}
        {showLoadCandidateModal && (
          <div
            className="modal fade show d-block"
            tabIndex={-1}
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl" style={{
              maxHeight: "600px",      // <-- reduces modal height
            }}>
              <div className="modal-content" style={{ height: "600px", display: "flex", flexDirection: "column" }}>

                {/* Header */}
                <div className="modal-header">
                  <h5 className="modal-title">Select Candidate</h5>
                  <button className="btn-close" onClick={() => {
                    setShowLoadCandidateModal(false);
                    setSelectedCandidate(null);
                    setCurrentPageCandidates(1);
                    setSearchTermCandidates("")
                  }} />
                </div>

                {/* Body */}
                <div className="modal-body p-0" style={{ overflowY: "hidden", flex: 1 }}>
                  <div className="content">
                    <div className="card card-margin-bottom mb-0">
                      <div
                        className="card-body p-0"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          overflow: "hidden"
                        }}
                      >

                        {/* Search Field (Triggers API) */}
                        <div className="d-flex align-items-center gap-2 mb-2">
                          {searchTermCandidates.trim() && (
                            <button
                              className="btn add_btn_size btn-outline-primary reset-vendor"
                              onClick={handleResetFiltersCandidates}
                              title="Reset"
                            >
                              <i className="ti ti-refresh" />
                            </button>
                          )}

                          <input
                            type="text"
                            className="form-control flex-grow-1"
                            placeholder="Search by name or email…"
                            value={searchTermCandidates}
                            onChange={(e) => setSearchTermCandidates(e.target.value)}
                          />
                        </div>

                        {/* Table */}
                        <div
                          style={{
                            height: "415px",
                            overflowY: "auto",
                            overflowX: "hidden",
                            display: "flex",
                            flexDirection: "column",
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                            background: "#fff",
                          }}
                        >
                         {showCandidateTable ? (
                          <Table
                            style={{ flex: 1 }}
                            loading={loadingCandidates}
                            currentPage={currentPageCandidates}
                            pageSize={12}
                            dataSource={candidates}
                            totalItems={totalItemsCandidates}
                            onPageChange={(page) => setCurrentPageCandidates(page)}
                            columns={[
                              { title: "Name", dataIndex: "name" },
                              { title: "Email", dataIndex: "email" },
                              {
                                title: "Experience",
                                render: (row: Candidate) =>
                                  `${Math.floor(row.total_experience_months / 12)}y ${row.total_experience_months % 12
                                  }m`,
                              },
                              {
                                title: "CTC",
                                dataIndex: "ctc_info",
                                render: (val: Candidate) => (val ? `${val} LPA` : "-"),
                              },
                              { title: "Location", dataIndex: "current_location" },
                            ]}
                            onRowClick={(row) => setSelectedCandidate(row)}
                            selectedRow={selectedCandidate}
                          />
                           ) : (
                                  <div
                                    style={{
                                      height: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      flexDirection: "column",
                                    }}
                                    className="text-muted"
                                  >
                                    <i className="ti ti-database-off fs-2 mb-2" />
                                    No data found
                                  </div>
                                )}
                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                {/* Footer */}
                <div className="modal-footer">
                  <button className="btn btn-light me-2" onClick={() => {
                    setShowLoadCandidateModal(false);
                    setSelectedCandidate(null);
                    setCurrentPageCandidates(1);
                    setSearchTermCandidates("")
                  }}>
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    disabled={!selectedCandidate}
                    onClick={() => {
                      setShowLoadCandidateModal(false);
                      setCurrentPageCandidates(1);
                      setSearchTermCandidates("")
                      setShowInterviewModal(true);
                    }}
                  >
                    Proceed
                  </button>
                </div>

              </div>
            </div>
          </div>
        )}

        {/* Schedule Interview Modal */}
        <ScheduleInterviewModal
          show={showInterviewModal}
          onClose={handleCloseModal}
          jobId={selectedJob?.id ?? 0}
          jobProfile={selectedJob?.job_profile ?? ""}
          mode={interviewMode}
          initialData={{
            candidateId: selectedCandidate?.id ?? undefined, // undefined if new candidate
            candidateName: selectedCandidate?.name ?? "",
            candidateEmail: selectedCandidate?.email ?? "",
            totalExperienceMonths: selectedCandidate?.total_experience_months ?? 0,
            currentCTC: selectedCandidate?.ctc_info ?? 0,
            expectedCTC: selectedCandidate?.expected_ctc ?? 0,
            currentLocation: selectedCandidate?.current_location ?? "",
            resumeFileName: selectedCandidate?.file_name ?? "",
          }}
          onSuccess={handleSuccess}
        />
        {/* Info Modal */}
        {showInfoModal && (
          <div
            className="modal fade show d-block"
            tabIndex={-1}
            role="dialog"
            style={{ background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered modal-xl" style={{
                      maxHeight: "600px",      // <-- reduces modal height
                    }}>
              <div
                className="modal-content"
                style={{ height: "600px", display: "flex", flexDirection: "column" , overflow: "hidden"}}
              >
                {/* HEADER */}
                <div className="modal-header pb-0">
                  <div>
                    <h5 className="modal-title mb-0">Candidates for Job</h5>
                    <small className="text-muted">{infoJob?.job_profile}</small>
                  </div>
                  <button
                    className="btn-close"
                    onClick={() => {
                      setShowInfoModal(false);
                      setInfoCandidates([]);
                      setInfoJob(null);
                      setInfoSearchTerm("");
                      setInfoPage(1);
                    }}
                  />
                </div>

                {/* BODY */}
                <div
                  className="modal-body p-0"
                  style={{
                    overflow: "hidden",
                    flex: 1,
                  }}
                >
                  <div className="content">
                            <div className="card card-margin-bottom mb-0">
                              <div
                                className="card-body p-0"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  overflow: "hidden"
                                }}
                              >
                  {/* SEARCH BAR */}
                  <div className="d-flex align-items-center gap-2 mb-2">
                    {infoSearchTerm.trim() && (
                      <button
                        className="btn add_btn_size btn-outline-primary reset-vendor"
                        onClick={() => {
                          setInfoSearchTerm("");
                          setInfoPage(1);
                        }}
                        title="Reset"
                      >
                        <i className="ti ti-refresh" />
                      </button>
                    )}

                    <input
                      type="text"
                      className="form-control flex-grow-1"
                      placeholder="Search by name or email…"
                      value={infoSearchTerm}
                      onChange={(e) => {
                        setInfoSearchTerm(e.target.value);
                        setInfoPage(1);
                      }}
                    />
                  </div>

                  {/* TABLE CONTAINER – FULL WIDTH */}
                  <div
                    style={{
                      height: "410px",
                      overflowY: "auto",
                      overflowX: "hidden",
                      display: "flex",
                      flexDirection: "column",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      background: "#fff",
                    }}
                  >
                  {showInfoTable ? (  
                      <Table
                      style={{ flex: 1 }}
                      loading={loadingInfoCandidates}
                      currentPage={infoPage}
                      pageSize={12}
                      dataSource={infoCandidates}
                      totalItems={infoTotal}
                      onPageChange={(page) => setInfoPage(page)}
                      columns={[
                        {
                          title: "Name",
                          dataIndex: "name",
                          render: (_: any, row: any) => (
                            <span
                              className="fw-medium text-primary"
                              style={{ cursor: "pointer" }}
                              title="View interview rounds"
                              onClick={() => openInterviewFromInfoPopup(row)}
                            >
                              {row.name}
                            </span>
                          ),
                        },
                        { title: "Email", dataIndex: "email" },
                        {
                          title: "Experience",
                          render: (row: any) =>
                            `${Math.floor(row.total_experience_months / 12)}y ${
                              row.total_experience_months % 12
                            }m`,
                        },
                        {
                          title: "CTC",
                          dataIndex: "ctc_info",
                          render: (val: string) =>
                            val ? `${val} LPA` : "Not Available",
                        },
                        { title: "Location", dataIndex: "current_location" },
                      ]}
                      
                    />
                    ) : (
                        <div
                          style={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                          }}
                          className="text-muted"
                        >
                          <i className="ti ti-database-off fs-2 mb-2" />
                          No data found
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>

                {/* FOOTER */}
                <div className="modal-footer">
                  <button
                    className="btn btn-light me-2"
                    onClick={() => {
                      setShowInfoModal(false);
                      setInfoCandidates([]);
                      setInfoJob(null);
                      setInfoSearchTerm("");
                      setInfoPage(1);
                      setAllInfoCandidates([]);
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
        <Footer />
      </div>
      <ToastContainer position="top-right" autoClose={3000} /></>
  );
};
export default JobOpenings;